export const isoToDateTime = (isoDateString: string) => {
  const date = new Date(isoDateString);
  if (!isoDateString || isoDateString.length === 0 || date.toString() === "Invalid Date") {
    return null;
  }

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const weekday = new Date(date).toLocaleString("en-GB", {
    weekday: "short",
  });
  const day = new Date(date).toLocaleString("en-GB", {
    day: "2-digit",
  });
  const month = new Date(date).toLocaleString("en-GB", {
    month: "short",
  });
  const hh = hours < 10 ? `0${hours}` : hours;
  const mm = minutes < 10 ? `0${minutes}` : minutes;

  return `${hh}:${mm} ${weekday} ${day} ${month}`;
};